import { useState, useEffect } from 'react';
import { Card, Row, Col, List } from 'antd';
import { postRequest } from '../../../../services/requestService';
import { showErrorToast } from '../../../../services/notificationsService';
import { ZorbaSelect } from '../../../../components/forms';
import { Spinner } from '../../../../components/Spinner';

import './index.scss';

export const DealSubmissionStats = () => {
  const [stats, setStats] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDays, setSelectedDays] = useState(30);

  const daysOptions = [
    { text: 'Last 7 days', value: 7 },
    { text: 'Last 30 days', value: 30 },
    { text: 'Last 90 days', value: 90 },
    { text: 'Last 180 days', value: 180 },
    { text: 'Last 365 days', value: 365 },
  ];

  const fetchStats = async (days = selectedDays) => {
    setIsLoading(true);
    try {
      const response = await postRequest('/backoffice/deal-submission/stats', {
        selectedDays: days,
      });
      setStats(response?.data?.data || {});
    } catch (error) {
      showErrorToast('Failed to fetch deal submission statistics');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const handleDaysChange = (value) => {
    setSelectedDays(value);
    fetchStats(value);
  };

  if (isLoading) {
    return (
      <div className="deal-submission-stats__loading">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="deal-submission-stats">
      <div className="deal-submission-stats__header">
        <div className="deal-submission-stats__header__select-container">
          <ZorbaSelect
            options={daysOptions}
            value={selectedDays}
            onChange={handleDaysChange}
            className="deal-submission-stats-select"
            fullWidth
          />
        </div>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Card title="Top States" size="small">
            <List
              size="small"
              dataSource={stats.topStates || []}
              renderItem={(item) => (
                <List.Item>
                  <div className="deal-submission-stats__list-item">
                    <span>{item.state || item.stateCode}</span>
                    <span className="deal-submission-stats__list-item__count">
                      {item.count}
                    </span>
                  </div>
                </List.Item>
              )}
            />
          </Card>
        </Col>

        <Col xs={24} md={8}>
          <Card title="Top Cities" size="small">
            <List
              size="small"
              dataSource={stats.topCities || []}
              renderItem={(item) => (
                <List.Item>
                  <div className="deal-submission-stats__list-item">
                    <span>{`${item.city}, ${item.stateCode}`}</span>
                    <span className="deal-submission-stats__list-item__count">
                      {item.count}
                    </span>
                  </div>
                </List.Item>
              )}
            />
          </Card>
        </Col>

        <Col xs={24} md={8}>
          <Card title="Top Counties" size="small">
            <List
              size="small"
              dataSource={stats.topCounties || []}
              renderItem={(item) => (
                <List.Item>
                  <div className="deal-submission-stats__list-item">
                    <span>{`${item.county}, ${item.stateCode}`}</span>
                    <span className="deal-submission-stats__list-item__count">
                      {item.count}
                    </span>
                  </div>
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};
